export default __webpack_public_path__ + "static/media/n-spanish.32f07d3c.svg";